import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white dark:bg-dark-200 h-full transition-colors relative" }
const _hoisted_2 = { class: "flex bg-white dark:bg-dark-200 h-full relative" }
const _hoisted_3 = {
  key: 0,
  class: "w-full relative overflow-hidden"
}
const _hoisted_4 = {
  key: 1,
  class: "flex justify-center items-center flex-col gap-4 h-full w-full"
}
const _hoisted_5 = { class: "text-xs font-semibold text-gray-700 dark:text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_sidebar = _resolveComponent("app-sidebar")!
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_app_navbar = _resolveComponent("app-navbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_sidebar),
      (!_ctx.loadingState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_base_loader, { size: "medium" }),
            _createElementVNode("p", _hoisted_5, " Добро пожаловать, " + _toDisplayString(_ctx.username) + "! 👋 ", 1)
          ]))
    ]),
    _createVNode(_component_app_navbar)
  ]))
}